import styled from 'styled-components';

export const SectionBackgroundImageWrapper = styled.div`
  display: block;
  height: 100%;
  top: 0;
  left: 0;
  position: absolute;
  text-align: right;
  width: 100%;
  z-index: 0;

  @media (max-width: 970px) {
    height: 250px;
  }
`;

export const SectionBackgroundImage = styled.div`
  background: ${(props) => `url("${props.imageUrl}") center center`};
  background-size: cover;
  height: 100%;
  width: 55%;
  margin-left: ${(props) => (props.alt ? 'auto' : '0px')};

  @media (max-width: 970px) {
    width: 100%;
  }
`;

export const VideoWrapper = styled.div`
  width: 55%;
  height: 100%;
  position: relative;
  margin-left: ${(props) => (props.alt ? 'auto' : '0px')};

  @media (max-width: 970px) {
    width: 100%;
  }
`;
